import { call, put } from 'redux-saga/effects';

import { getFilingPeriodList } from '@api/filingTypes';
import { filingTypesOptionsSetModel } from '@models/filingTypes';
import {
  filingTypesOptionsFetchFailure,
  filingTypesOptionsFetchSuccess,
} from '@store/entityJurisdictions/entityJurisdictionsDetail/filingTypes/filingTypes.reducer';
import { toastError } from '@store/notifications';

export const filingTypeOptionsFetchSaga = function* ({ payload }) {
  try {
    const periodResponse = yield call(getFilingPeriodList, payload.entityJurisdictionId);

    yield put(
      filingTypesOptionsFetchSuccess({
        filingTypes: filingTypesOptionsSetModel(periodResponse?.results),
        userExperiences: periodResponse?.userExperiences || [],
      })
    );
  } catch (error) {
    const { nonFieldErrors, hasNonFieldError } = error.data || {};

    yield put([
      toastError({
        message: hasNonFieldError
          ? nonFieldErrors
          : {
              defaultMessage: 'Failed to fetch filing type options.',
              id: 'pages.registrations.filing-type-options-fetch.notification.error',
            },
      }),
      filingTypesOptionsFetchFailure(),
    ]);
  }
};
